var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"36","cy":"36","r":"34.5","fill":"none","stroke":"inherit","strokeLinecap":"round","strokeMiterlimit":"10","strokeWidth":"3","key":0}),React.createElement("path",{"fill":"none","stroke":"inherit","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"6","d":"M22.19 37.47l8.69 8.48 20.93-19.72","key":1})]);
}

Tick.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 72 72"};

module.exports = Tick;

Tick.default = Tick;
